  export const DEFAULT_SOLIDS = [
  '#000000', '#111111', '#1A1A1A', '#333333', '#4A4A4A', '#666666', '#808080',
  '#999999', '#B3B3B3', '#CCCCCC', '#E0E0E0', '#F2F2F2', '#FFFFFF',
  '#F5F0E8', '#EDE3D5', '#D9C9B2', '#C9A962', '#B8860B', '#8B6B3A',
  '#5A4525', '#2E2315', '#0B0D0F', '#0E1B2A', '#142236', '#1B2B45',
  '#223B5A', '#2B4C73', '#355E8B', '#3F71A4', '#4A85BE', '#5599D8',
  '#69B0F2', '#8CC5FF', '#B3D9FF', '#D6EBFF',
  '#0F3D2E', '#145C44', '#1C7A5A', '#2D9C73', '#49C28C', '#76D9A8',
  '#A5EAC8', '#D7F7E6',
  '#3D0F2E', '#5B1451', '#7A1C73', '#9C2D94', '#C249B1', '#D976C6',
  '#EAA5DA', '#F7D6EB',
  '#3B1C0A', '#5A2A10', '#7A3A18', '#9C4C20', '#C2682D', '#D98B4A',
  '#E9B07A', '#F4D4B0',
  '#2D0A0A', '#4A1010', '#7A1C1C', '#A32D2D', '#C94A4A', '#E07171',
  '#F3A1A1', '#FAD1D1',
  '#0A2D3B', '#104A5A', '#1C6A7A', '#2D879C', '#49AFC2', '#76CAD9',
  '#A5E1EA', '#D7F4F7',
  '#2E1B3B', '#45235A', '#5B2D7A', '#73359C', '#8B4AC2', '#A071D9',
  '#C0A5EA', '#E1D7F7',
  '#0A3B2A', '#0F5A3E', '#1C7A54', '#2D9C6C', '#49C28C', '#76D9A8',
];

export const DEFAULT_GRADIENTS = [
  {
    paint: {
      type: 'gradient',
      kind: 'linear',
      angle: 45,
      stops: [
        { color: '#FF4D4D', alpha: 100, pos: 0 },
        { color: '#FFB84D', alpha: 100, pos: 100 },
      ],
    },
    tags: ['sunset', 'warm', 'orange'],
  },
  {
    paint: {
      type: 'gradient',
      kind: 'linear',
      angle: 120,
      stops: [
        { color: '#1A2A6C', alpha: 100, pos: 0 },
        { color: '#B21F1F', alpha: 100, pos: 100 },
      ],
    },
    tags: ['noir', 'dramatic'],
  },
  {
    paint: {
      type: 'gradient',
      kind: 'linear',
      angle: 90,
      stops: [
        { color: '#0F2027', alpha: 100, pos: 0 },
        { color: '#2C5364', alpha: 100, pos: 100 },
      ],
    },
    tags: ['ocean', 'deep', 'cool'],
  },
  {
    paint: {
      type: 'gradient',
      kind: 'linear',
      angle: 60,
      stops: [
        { color: '#C9A962', alpha: 100, pos: 0 },
        { color: '#F5E3B0', alpha: 100, pos: 100 },
      ],
    },
    tags: ['gold', 'luxury'],
  },
  {
    paint: {
      type: 'gradient',
      kind: 'linear',
      angle: 180,
      stops: [
        { color: '#0F0F0F', alpha: 100, pos: 0 },
        { color: '#333333', alpha: 100, pos: 100 },
      ],
    },
    tags: ['monochrome', 'dark'],
  },
  {
    paint: {
      type: 'gradient',
      kind: 'linear',
      angle: 135,
      stops: [
        { color: '#F8F9FA', alpha: 100, pos: 0 },
        { color: '#DEE2E6', alpha: 100, pos: 100 },
      ],
    },
    tags: ['neutral', 'light'],
  },
  {
    paint: {
      type: 'gradient',
      kind: 'linear',
      angle: 40,
      stops: [
        { color: '#D4A5A5', alpha: 100, pos: 0 },
        { color: '#FFE8D6', alpha: 100, pos: 100 },
      ],
    },
    tags: ['pastel', 'rose'],
  },
  {
    paint: {
      type: 'gradient',
      kind: 'linear',
      angle: 20,
      stops: [
        { color: '#B5EAD7', alpha: 100, pos: 0 },
        { color: '#C7CEEA', alpha: 100, pos: 100 },
      ],
    },
    tags: ['mint', 'cool', 'pastel'],
  },
  {
    paint: {
      type: 'gradient',
      kind: 'linear',
      angle: 90,
      stops: [
        { color: '#00C6FF', alpha: 100, pos: 0 },
        { color: '#0072FF', alpha: 100, pos: 100 },
      ],
    },
    tags: ['blue', 'neon'],
  },
  {
    paint: {
      type: 'gradient',
      kind: 'linear',
      angle: 90,
      stops: [
        { color: '#F953C6', alpha: 100, pos: 0 },
        { color: '#B91D73', alpha: 100, pos: 100 },
      ],
    },
    tags: ['magenta', 'neon'],
  },
  {
    paint: {
      type: 'gradient',
      kind: 'radial',
      angle: 0,
      stops: [
        { color: '#FFFFFF', alpha: 100, pos: 0 },
        { color: '#C9A962', alpha: 100, pos: 100 },
      ],
    },
    tags: ['radial', 'gold'],
  },
  {
    paint: {
      type: 'gradient',
      kind: 'linear',
      angle: 160,
      stops: [
        { color: '#1B1B1B', alpha: 100, pos: 0 },
        { color: '#5C5C5C', alpha: 100, pos: 100 },
      ],
    },
    tags: ['graphite', 'neutral'],
  },
  {
    paint: {
      type: 'gradient',
      kind: 'linear',
      angle: 50,
      stops: [
        { color: '#FFDEE9', alpha: 100, pos: 0 },
        { color: '#B5FFFC', alpha: 100, pos: 100 },
      ],
    },
    tags: ['pastel', 'soft'],
  },
  {
    paint: {
      type: 'gradient',
      kind: 'linear',
      angle: 75,
      stops: [
        { color: '#FDFBFB', alpha: 100, pos: 0 },
        { color: '#EBEDEE', alpha: 100, pos: 100 },
      ],
    },
    tags: ['mist', 'neutral'],
  },
  {
    paint: {
      type: 'gradient',
      kind: 'linear',
      angle: 135,
      stops: [
        { color: '#FAD0C4', alpha: 100, pos: 0 },
        { color: '#FFD1FF', alpha: 100, pos: 100 },
      ],
    },
    tags: ['peach', 'pink'],
  },
  {
    paint: {
      type: 'gradient',
      kind: 'linear',
      angle: 45,
      stops: [
        { color: '#2193B0', alpha: 100, pos: 0 },
        { color: '#6DD5ED', alpha: 100, pos: 100 },
      ],
    },
    tags: ['aqua', 'fresh'],
  },
  {
    paint: {
      type: 'gradient',
      kind: 'linear',
      angle: 30,
      stops: [
        { color: '#CC2B5E', alpha: 100, pos: 0 },
        { color: '#753A88', alpha: 100, pos: 100 },
      ],
    },
    tags: ['purple', 'sunset'],
  },
  {
    paint: {
      type: 'gradient',
      kind: 'linear',
      angle: 110,
      stops: [
        { color: '#42275A', alpha: 100, pos: 0 },
        { color: '#734B6D', alpha: 100, pos: 100 },
      ],
    },
    tags: ['violet', 'moody'],
  },
  {
    paint: {
      type: 'gradient',
      kind: 'linear',
      angle: 15,
      stops: [
        { color: '#614385', alpha: 100, pos: 0 },
        { color: '#516395', alpha: 100, pos: 100 },
      ],
    },
    tags: ['indigo'],
  },
  {
    paint: {
      type: 'gradient',
      kind: 'linear',
      angle: 90,
      stops: [
        { color: '#F12711', alpha: 100, pos: 0 },
        { color: '#F5AF19', alpha: 100, pos: 100 },
      ],
    },
    tags: ['fire', 'warm'],
  },
  {
    paint: {
      type: 'gradient',
      kind: 'linear',
      angle: 35,
      stops: [
        { color: '#8360C3', alpha: 100, pos: 0 },
        { color: '#2EBF91', alpha: 100, pos: 100 },
      ],
    },
    tags: ['mint', 'purple'],
  },
  {
    paint: {
      type: 'gradient',
      kind: 'linear',
      angle: 120,
      stops: [
        { color: '#00B4DB', alpha: 100, pos: 0 },
        { color: '#0083B0', alpha: 100, pos: 100 },
      ],
    },
    tags: ['blue', 'cool'],
  },
  {
    paint: {
      type: 'gradient',
      kind: 'linear',
      angle: 140,
      stops: [
        { color: '#F7971E', alpha: 100, pos: 0 },
        { color: '#FFD200', alpha: 100, pos: 100 },
      ],
    },
    tags: ['gold', 'sun'],
  },
  {
    paint: {
      type: 'gradient',
      kind: 'linear',
      angle: 160,
      stops: [
        { color: '#5F2C82', alpha: 100, pos: 0 },
        { color: '#49A09D', alpha: 100, pos: 100 },
      ],
    },
    tags: ['teal', 'purple'],
  },
  {
    paint: {
      type: 'gradient',
      kind: 'linear',
      angle: 200,
      stops: [
        { color: '#232526', alpha: 100, pos: 0 },
        { color: '#414345', alpha: 100, pos: 100 },
      ],
    },
    tags: ['steel', 'dark'],
  },
  {
    paint: {
      type: 'gradient',
      kind: 'linear',
      angle: 90,
      stops: [
        { color: '#FFE259', alpha: 100, pos: 0 },
        { color: '#FFA751', alpha: 100, pos: 100 },
      ],
    },
    tags: ['amber'],
  },
  {
    paint: {
      type: 'gradient',
      kind: 'linear',
      angle: 130,
      stops: [
        { color: '#4E54C8', alpha: 100, pos: 0 },
        { color: '#8F94FB', alpha: 100, pos: 100 },
      ],
    },
    tags: ['blue', 'lavender'],
  },
  {
    paint: {
      type: 'gradient',
      kind: 'radial',
      angle: 0,
      stops: [
        { color: '#FFFFFF', alpha: 100, pos: 0 },
        { color: '#EDE3D5', alpha: 100, pos: 100 },
      ],
    },
    tags: ['cream', 'radial'],
  },
  {
    paint: {
      type: 'gradient',
      kind: 'linear',
      angle: 45,
      stops: [
        { color: '#FCE38A', alpha: 100, pos: 0 },
        { color: '#F38181', alpha: 100, pos: 100 },
      ],
    },
    tags: ['peach', 'sunset'],
  },
  {
    paint: {
      type: 'gradient',
      kind: 'linear',
      angle: 135,
      stops: [
        { color: '#E0EAFC', alpha: 100, pos: 0 },
        { color: '#CFDEF3', alpha: 100, pos: 100 },
      ],
    },
    tags: ['sky', 'soft'],
  },
  {
    paint: {
      type: 'gradient',
      kind: 'linear',
      angle: 100,
      stops: [
        { color: '#DCE35B', alpha: 100, pos: 0 },
        { color: '#45B649', alpha: 100, pos: 100 },
      ],
    },
    tags: ['green', 'fresh'],
  },
  {
    paint: {
      type: 'gradient',
      kind: 'linear',
      angle: 170,
      stops: [
        { color: '#EDC7B7', alpha: 100, pos: 0 },
        { color: '#EEE2DC', alpha: 100, pos: 100 },
      ],
    },
    tags: ['nude', 'soft'],
  },
  {
    paint: {
      type: 'gradient',
      kind: 'linear',
      angle: 210,
      stops: [
        { color: '#141E30', alpha: 100, pos: 0 },
        { color: '#243B55', alpha: 100, pos: 100 },
      ],
    },
    tags: ['navy', 'night'],
  },
  {
    paint: {
      type: 'gradient',
      kind: 'linear',
      angle: 95,
      stops: [
        { color: '#FFECD2', alpha: 100, pos: 0 },
        { color: '#FCB69F', alpha: 100, pos: 100 },
      ],
    },
    tags: ['peach', 'soft'],
  },
  {
    paint: {
      type: 'gradient',
      kind: 'linear',
      angle: 135,
      stops: [
        { color: '#C9FFBF', alpha: 100, pos: 0 },
        { color: '#FFAFBD', alpha: 100, pos: 100 },
      ],
    },
    tags: ['mint', 'pink'],
  },
  {
    paint: {
      type: 'gradient',
      kind: 'linear',
      angle: 60,
      stops: [
        { color: '#606C88', alpha: 100, pos: 0 },
        { color: '#3F4C6B', alpha: 100, pos: 100 },
      ],
    },
    tags: ['steel', 'cool'],
  },
  {
    paint: {
      type: 'gradient',
      kind: 'linear',
      angle: 15,
      stops: [
        { color: '#FFC3A0', alpha: 100, pos: 0 },
        { color: '#FFAFBD', alpha: 100, pos: 100 },
      ],
    },
    tags: ['rose', 'warm'],
  },
];
